import { BeRow, BeScrollBar } from "@beos-css/react/index.ts";
import { useState } from "react";

export function ScrollBarsDemo() {
	const [sbH, setSbH] = useState(25);
	const [sbV, setSbV] = useState(40);

	return (
		<section id="demo-scrollbar">
			<h2>Scroll bars (BScrollBar)</h2>
			<p>
				The R5 scrollbar is drawn server-side (TScrollBar decomp); this is a DOM recreation with the binary's arrow bitmaps. Drag the thumb,
				hold the arrows, click the track to page. The knob style was a Scroll Bar preference.
			</p>
			<BeRow wrap gap="row">
				<BeScrollBar orientation="horizontal" value={sbH} max={100} proportion={0.35} onChange={setSbH} length={200} label="Plain" />
				<BeScrollBar orientation="horizontal" value={0} max={0} length={200} label="Disabled (empty range)" />
				<BeScrollBar
					orientation="horizontal"
					value={sbH}
					max={100}
					proportion={0.35}
					knob="none"
					inactive
					onChange={setSbH}
					length={200}
					label="No knob, inactive window"
				/>
			</BeRow>
			<BeRow wrap gap="row">
				<BeScrollBar orientation="vertical" value={sbV} max={100} proportion={0.3} onChange={setSbV} length={160} label="Vertical" />
				<BeScrollBar orientation="vertical" value={0} max={0} length={160} label="Vertical, disabled" />
			</BeRow>
		</section>
	);
}
